export default __webpack_public_path__ + "static/media/logisticaIcone.e76f4bd2.svg";